module.exports = __webpack_public_path__ + "static/img/declaration-info.5b4d589b.svg";